/**
 * The outside image hosts that our imgproxy may fetch from: the cover CDNs of the music services.
 * Keep in step with `IMGPROXY_ALLOWED_SOURCES` in docker-prod (`docker/{production,staging}/imgproxy`)
 * and with `SERVICE_COVER_SOURCES` in musicapi (`src/services/fym/covers/proxiedCoverUrl.ts`).
 * A `*` matches any characters except `/`, as in imgproxy.
 *
 * Our own files are not in this list: the API sends their imgproxy source (`sourceUrl`) itself.
 */
export const IMGPROXY_REMOTE_SOURCES: readonly string[] = [
  'https://i.scdn.co/',
  'https://mosaic.scdn.co/',
  'https://*.spotifycdn.com/',
  'https://*.mzstatic.com/',
  'https://*.blobstore.apple.com/',
  'https://resources.tidal.com/',
  'https://images.tidal.com/',
  'https://static.qobuz.com/',
  'https://m.media-amazon.com/',
  'https://images-na.ssl-images-amazon.com/',
  'https://i.ytimg.com/',
  'https://lh3.googleusercontent.com/',
  'https://yt3.googleusercontent.com/',
  'https://yt3.ggpht.com/',
  'https://*.dzcdn.net/',
  'https://*.sndcdn.com/',
  'https://*.p-cdn.com/',
  'https://api.napster.com/imageserver/',
  'https://direct.rhapsody.com/imageserver/',
  'https://avatars.yandex.net/',
  'https://c.saavncdn.com/',
  'https://*.boomplaymusic.com/',
  'https://assets.audiomack.com/',
];

const escapeRegExp = (text: string): string => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const sourcePatterns: readonly RegExp[] = IMGPROXY_REMOTE_SOURCES.map(
  (source) => new RegExp(`^${source.split('*').map(escapeRegExp).join('[^/]*')}`)
);

/** Whether imgproxy may fetch this outside URL (a music service cover CDN). */
export const isProxiableRemoteImage = (url: string): boolean => sourcePatterns.some((pattern) => pattern.test(url));
